import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import { Modal, Button } from 'semantic-ui-react'

import toastr from 'libs/toast'
import useAxios, { mutate } from 'hooks/useAxios'
import constants from 'config/constants'
import usePermission from 'hooks/usePermission'
import ErrorText from 'shared/components/forms/ErrorText'

export function AddDomainModal({ isForceModalOpen, existingDomains }) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [domainName, setDomainName] = useState('')
  const [duplicateError, setDuplicateError] = useState(false)
  const [requiredError, setRequiredError] = useState(false)
  const { hasPermission } = usePermission()
  const hasManageEmailAuthenticationPermission = hasPermission(
    constants.permissions.manageEmailAuthentication
  )

  const { fetch: callCreateDomain, loading: creatingDomain } = useAxios({
    url: 'sendgrid/whitelabel/domains',
    method: 'post',
    skip: true,
  })

  const showModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(!isModalOpen)
    setDomainName('')
    setDuplicateError(false)
    setRequiredError(false)
  }

  const onChangeText = (event) => {
    const value = event.target.value
    setDomainName(value)
    setRequiredError(false)

    const sanitized = value.replace(/[^a-zA-Z0-9.-]/g, '').toLowerCase()
    const isDuplicate =
      Array.isArray(existingDomains) &&
      existingDomains.some((d) => d.domain.toLowerCase() === sanitized)
    setDuplicateError(isDuplicate)
  }

  const createDomain = () => {
    if (R.isEmpty(domainName.trim())) {
      setRequiredError(true)
      return
    }

    if (duplicateError) {
      return
    }

    const sanitizedDomain = domainName.replace(/[^a-zA-Z0-9.-]/g, '')
    callCreateDomain({
      data: {
        domain: sanitizedDomain,
        automatic_security: true,
        custom_dkim_selector: 'sim',
      },
    })
      .then((response) => {
        mutate(
          'sendgrid/whitelabel/domains?limit=500',
          (domains = []) => {
            const updatedDomains = [...domains, response.data]

            updatedDomains.sort((a, b) => a.domain.localeCompare(b.domain))

            return updatedDomains
          },
          false
        )
        toastr.success('Domain created successfully.')
        closeModal()
      })
      .catch((error) => {
        toastr.error(
          error?.response?.data?.detail ||
            'Could not add domain. Contact support for help.'
        )
        closeModal()
      })
  }

  const keyPress = (event) => {
    if (event.keyCode === 13 && !creatingDomain) {
      createDomain()
    }
  }

  useEffect(() => {
    if (isForceModalOpen) {
      showModal()
    }
  }, [isForceModalOpen])

  const hasError = duplicateError || requiredError

  return (
    <Modal
      className="coupled small modal"
      open={isModalOpen}
      onOpen={showModal}
      onClose={closeModal}
      trigger={
        hasManageEmailAuthenticationPermission ? (
          <Button primary>
            <i className="icon far fa-plus" />
            New domain
          </Button>
        ) : null
      }
    >
      <Modal.Header>
        <i className="far fa-globe icon" />
        Add domain to authenticate
      </Modal.Header>
      <Modal.Content>
        <div className="ui form">
          <div className={`field${hasError ? ' error' : ''}`}>
            <label>Domain</label>
            <input
              type="text"
              name="domain-name"
              value={domainName}
              onChange={onChangeText}
              onKeyDown={keyPress}
            />
            {requiredError && <ErrorText>Domain is required.</ErrorText>}
            {duplicateError && (
              <ErrorText>This domain already exists. Use a different domain.</ErrorText>
            )}
          </div>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={closeModal}>Cancel</Button>
        <Button
          primary
          onClick={createDomain}
          loading={creatingDomain}
          disabled={creatingDomain || duplicateError}
        >
          Add domain
        </Button>
      </Modal.Actions>
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/AddDomainModal/index.js